import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import i18n from 'src/lib/i18n/i18n';
import gsap from 'gsap';
import { downscale } from 'src/conf/scale';

export class TimesUp extends View {
  private content: View;
  private frame: ImageScaleView;
  private text: LangBitmapFontTextView;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
    });

    this.content = new View({
      superview: this,
    });

    this.frame = new ImageScaleView({
      superview: this.content,
      image: 'assets/minigame/rescueLevel/rounded_frame.png',
      width: downscale(609),
      height: downscale(222),
      centerOnOrigin: true,
    });

    this.text = new LangBitmapFontTextView({
      superview: this.frame,
      x: this.frame.style.width / 2,
      y: this.frame.style.height / 2,
      align: 'center',
      verticalAlign: 'center',
      size: 46,
      font: 'Title',
      width: this.frame.style.width - 40,
      height: this.frame.style.height - 20,
      color: '#ffffff',
      centerOnOrigin: true,
      localeText: () => i18n('rescueLevel.common.timesUp'),
    });
  }

  public updateOpts(opts: ViewOpts) {
    const result = super.updateOpts(opts);
    this.content.updateOpts({
      x: this.style.width / 2,
      y: this.style.height / 2 - 100,
    });
    return result;
  }

  public async showAnimated() {
    this.updateOpts({
      opacity: 0,
      visible: true,
    });

    this.frame.updateOpts({
      y: 400,
    });

    gsap.to(this.style, {
      opacity: 1,
      duration: 0.2,
      ease: 'linear',
    });

    await gsap.to(this.frame.style, {
      y: 0,
      duration: 0.5,
      ease: 'back.out',
    });
  }
}
